import { Modal as BaseModal, ModalCloseReason } from "@bokio/design-system-base/components/Modal";
import { DisableGlobalFileDropZone } from "@bokio/hooks/useDisableGlobalFileDropZone/useDisableGlobalFileDropZone";

import type { ModalProps } from "@bokio/design-system-base/components/Modal";
import type { PropsWithChildren } from "react";

export { ModalCloseReason };
export type { ModalProps };

export const Modal = ({ alwaysMounted = false, children, ...props }: PropsWithChildren<ModalProps>) => {
	return (
		<BaseModal {...props} alwaysMounted={alwaysMounted}>
			{!alwaysMounted && <DisableGlobalFileDropZone />}
			{children}
		</BaseModal>
	);
};
